// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General App Styles */
.App {
  text-align: left;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.container {
  margin-top: 30px;
}


/* Font Styles */
h1, h2, h3, h4, p, a {
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  padding: 0;
}

/* Body Style */
body {
  padding-top: 120px; /* Space for the fixed header */
}

/* Top Bar Styles */
.top-bar-container {
  background-color: #08062b;
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 100;
  padding: 0px 0;
  height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.top-links {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 5px;
  font-size: 15px;
  color: #fff;
}

.top-links a {
  margin-right: 15px;
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s;
}

.top-links a:hover {
  color: #007bff;
}

/* University Name and Logo */
.university-name-container {
  display: flex;
  align-items: center; /* Aligns items vertically in the center */
  gap: 10px;
  padding: 45px;
  padding-bottom: 15px;
  background-color: #ffffff;
  color: #08062b;
}

.university-logo {
  width: 100px; /* Adjust the size of the logo as needed */
  height: 100px;
  object-fit: cover; /* Ensures the image scales properly */
  margin-right: 25px; 
}

.university-name-main {
  font-family: 'Roboto', sans-serif;
  font-size: 2rem; /* Adjust size as needed */
  font-weight: 700; /* Use bold weight */
  color: #432e9a; /* Adjust color if necessary */
  text-align: center;
}

.university-name-sub {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem; /* Adjust size as needed */
  font-weight: 400; /* Use normal weight */
  color: #555; /* Adjust color if necessary */
  text-align: center;
}




.university-logo-and-name {
  display: flex;
  flex-direction: row; /* Ensures the main and sub names stack vertically */
  line-height: 1; /* Adds a consistent line height */
  align-items: center; 
}




/*Footer Styles */
/* footer {
  background-color : "#142651";
   color: "#ffffff"; 
   padding: "20px 0";
}

footer .footer-navigation {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  margin-right: 30px;
  padding: 30px;
  list-style: none;
}
footer.list-unstyled{
  background-color: #007bff;
}
footer .footer-navigation li {
  margin: 5px ;
  color:rgb(173, 204, 238);
  font-family: Arial, Helvetica, sans-serif;

}

footer .footer-social-icons {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 10px 0;
}

footer .footer-social-icons li {
  margin: 0 10px;
}

footer .footer-social-icons svg {
  width: 32px;
  height: 32px;
  fill: #a7a7e3;
  transition: transform 0.3s;
}

footer .footer-social-icons svg:hover {
  transform: scale(1.2);
} */
.list{
  color: #ffffff;
    text-decoration: none;
    font-size: 0.9 rem;
    font-family: 'Raleway',sans-serif;
    list-style: none; /* Remove default bullet points */
  position: relative;
  padding-left: 20px;
}
.list::before {
  content: ">"; /* Unicode arrow character */
  position: absolute;
  left: 0;
  color: #ffffff; /* Red color */
  font-size: 16px;
}
.logo{
  font-family: Trebuchet MS;
  font-size: bold;
  color: #a8bcff;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  font-size: 1rem;

}
@media (max-width: 768px) {
  .logo {
    font-size: 0.875rem;
    text-align: center;
  }
}
.headings{
  color: #b5b3e3;
  font-family:'Raleway', sans-serif;
  font-weight: bolder;
 }
 .footer-link {

    color: #ffffff;
    text-decoration: none;
    transition: color 0.3s ease;
  }

 .footer-link:hover {
    color: #6ca5c8;
  }


/* Responsive Adjustments */
@media only screen and (max-width: 992px) {
  .top-bar-container {
    height: auto;
    padding: 8px 10px;
  }

  .top-links {
    font-size: 0.8em;
  }

  .university-name-container {
    flex-direction: column;
    padding: 15px;
  }

  .university-logo {
    height: 50px;
  }

  .university-name-main {
    font-size: 1.5rem;
  }

  .university-name-sub {
    font-size: 0.9rem;
  }

  .navbar .nav-link {
    font-size: 14px;
  }
}

@media only screen and (max-width: 768px) {
  .top-bar-container {
    padding: 5px 5px;
  }

  .university-logo {
    height: 40px;
  }

  .navbar .nav-link {
    font-size: 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,SAAS;EACT,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,kBAAkB,EAAE,+BAA+B;AACrD;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB,EAAE,0CAA0C;EAC/D,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,0CAA0C;EACxD,aAAa;EACb,iBAAiB,EAAE,sCAAsC;EACzD,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe,EAAE,0BAA0B;EAC3C,gBAAgB,EAAE,oBAAoB;EACtC,cAAc,EAAE,8BAA8B;EAC9C,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB,EAAE,0BAA0B;EAC7C,gBAAgB,EAAE,sBAAsB;EACxC,WAAW,EAAE,8BAA8B;EAC3C,kBAAkB;AACpB;;;;;AAKA;EACE,aAAa;EACb,mBAAmB,EAAE,oDAAoD;EACzE,cAAc,EAAE,kCAAkC;EAClD,mBAAmB;AACrB;;;;;AAKA,iBAAiB;AACjB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6CG;AACH;EACE,cAAc;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB,EAAE,iCAAiC;EACrD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY,EAAE,4BAA4B;EAC1C,kBAAkB;EAClB,OAAO;EACP,cAAc,EAAE,cAAc;EAC9B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,eAAe;;AAEjB;AACA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,mBAAmB;CACpB;CACA;;IAEG,cAAc;IACd,qBAAqB;IACrB,2BAA2B;EAC7B;;CAED;IACG,cAAc;EAChB;;;AAGF,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');\n\n\n/* General App Styles */\n.App {\n  text-align: left;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n.container {\n  margin-top: 30px;\n}\n\n\n/* Font Styles */\nh1, h2, h3, h4, p, a {\n  font-family: 'Montserrat', sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n/* Body Style */\nbody {\n  padding-top: 120px; /* Space for the fixed header */\n}\n\n/* Top Bar Styles */\n.top-bar-container {\n  background-color: #08062b;\n  width: 100%;\n  position: fixed;\n  top: 0px;\n  z-index: 100;\n  padding: 0px 0;\n  height: 60px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.top-links {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0 5px;\n  font-size: 15px;\n  color: #fff;\n}\n\n.top-links a {\n  margin-right: 15px;\n  color: #ffffff;\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\n.top-links a:hover {\n  color: #007bff;\n}\n\n/* University Name and Logo */\n.university-name-container {\n  display: flex;\n  align-items: center; /* Aligns items vertically in the center */\n  gap: 10px;\n  padding: 45px;\n  padding-bottom: 15px;\n  background-color: #ffffff;\n  color: #08062b;\n}\n\n.university-logo {\n  width: 100px; /* Adjust the size of the logo as needed */\n  height: 100px;\n  object-fit: cover; /* Ensures the image scales properly */\n  margin-right: 25px; \n}\n\n.university-name-main {\n  font-family: 'Roboto', sans-serif;\n  font-size: 2rem; /* Adjust size as needed */\n  font-weight: 700; /* Use bold weight */\n  color: #432e9a; /* Adjust color if necessary */\n  text-align: center;\n}\n\n.university-name-sub {\n  font-family: 'Roboto', sans-serif;\n  font-size: 1.2rem; /* Adjust size as needed */\n  font-weight: 400; /* Use normal weight */\n  color: #555; /* Adjust color if necessary */\n  text-align: center;\n}\n\n\n\n\n.university-logo-and-name {\n  display: flex;\n  flex-direction: row; /* Ensures the main and sub names stack vertically */\n  line-height: 1; /* Adds a consistent line height */\n  align-items: center; \n}\n\n\n\n\n/*Footer Styles */\n/* footer {\n  background-color : \"#142651\";\n   color: \"#ffffff\"; \n   padding: \"20px 0\";\n}\n\nfooter .footer-navigation {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0;\n  margin-right: 30px;\n  padding: 30px;\n  list-style: none;\n}\nfooter.list-unstyled{\n  background-color: #007bff;\n}\nfooter .footer-navigation li {\n  margin: 5px ;\n  color:rgb(173, 204, 238);\n  font-family: Arial, Helvetica, sans-serif;\n\n}\n\nfooter .footer-social-icons {\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 10px 0;\n}\n\nfooter .footer-social-icons li {\n  margin: 0 10px;\n}\n\nfooter .footer-social-icons svg {\n  width: 32px;\n  height: 32px;\n  fill: #a7a7e3;\n  transition: transform 0.3s;\n}\n\nfooter .footer-social-icons svg:hover {\n  transform: scale(1.2);\n} */\n.list{\n  color: #ffffff;\n    text-decoration: none;\n    font-size: 0.9 rem;\n    font-family: 'Raleway',sans-serif;\n    list-style: none; /* Remove default bullet points */\n  position: relative;\n  padding-left: 20px;\n}\n.list::before {\n  content: \">\"; /* Unicode arrow character */\n  position: absolute;\n  left: 0;\n  color: #ffffff; /* Red color */\n  font-size: 16px;\n}\n.logo{\n  font-family: Trebuchet MS;\n  font-size: bold;\n  color: #a8bcff;\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 100%;\n  font-size: 1rem;\n\n}\n@media (max-width: 768px) {\n  .logo {\n    font-size: 0.875rem;\n    text-align: center;\n  }\n}\n.headings{\n  color: #b5b3e3;\n  font-family:'Raleway', sans-serif;\n  font-weight: bolder;\n }\n .footer-link {\n\n    color: #ffffff;\n    text-decoration: none;\n    transition: color 0.3s ease;\n  }\n\n .footer-link:hover {\n    color: #6ca5c8;\n  }\n\n\n/* Responsive Adjustments */\n@media only screen and (max-width: 992px) {\n  .top-bar-container {\n    height: auto;\n    padding: 8px 10px;\n  }\n\n  .top-links {\n    font-size: 0.8em;\n  }\n\n  .university-name-container {\n    flex-direction: column;\n    padding: 15px;\n  }\n\n  .university-logo {\n    height: 50px;\n  }\n\n  .university-name-main {\n    font-size: 1.5rem;\n  }\n\n  .university-name-sub {\n    font-size: 0.9rem;\n  }\n\n  .navbar .nav-link {\n    font-size: 14px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .top-bar-container {\n    padding: 5px 5px;\n  }\n\n  .university-logo {\n    height: 40px;\n  }\n\n  .navbar .nav-link {\n    font-size: 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
